import { useEffect } from 'react';

/**
 * Observes images with [data-src] and lazy-loads them into [src] when visible.
 */
export const useLazyLoadImages = () => {
  useEffect(() => {
    const images = document.querySelectorAll('img[data-src]');
    if (!images.length) return undefined;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const img = entry.target;
        img.src = img.dataset.src;
        img.classList.remove('lazy-load');
        img.classList.add('loaded');
        observer.unobserve(img);
      });
    });

    images.forEach((img) => observer.observe(img));
    return () => observer.disconnect();
  }, []);
};
